module.exports = __webpack_public_path__ + "static/media/webfont.9d408804.woff";